<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Planes</h2>
    <div class="row mb-3 align-items-center">
      <div class="col-md-4">
        <button
          id="agregarPlan"
          class="btn btn-primary"
          (click)="abrirModoCreacionPlan()"
        >
          <fa-icon [icon]="faPlus" class="me-2"></fa-icon>
          Agregar Plan
        </button>
        <button
          id="reasignarPlanes"
          class="btn btn-secondary ms-2"
          (click)="reasignarPlanes()"
        >
          <fa-icon [icon]="faSync" class="me-2"></fa-icon>
          Reasignar Planes
        </button>
      </div>

      <div class="col-md-8 text-end spanSMVM">
        <div *ngIf="!editandoSalario; else editMode">
          <button
            class="btn btn-link p-0 editar-smvm"
            (click)="editarSalarioMVM()"
            title="Editar Salario"
            id="editarSMVM"
          >
            <span class="fw-bold">Salario Mínimo Vital y Móvil: </span>
            <span>{{
              salarioMVM | currency : "ARS $" : "symbol" : "1.2-2"
            }}</span>
            <fa-icon [icon]="faPencil" class="ms-2"></fa-icon>
          </button>
        </div>

        <!-- Modo edición -->
        <ng-template #editMode>
          <div>
            <span class="fw-bold">Salario Mínimo Vital y Móvil: </span>
            <input
              type="number"
              [(ngModel)]="salarioTemporal"
              class="form-control d-inline-block w-auto"
              min="0"
              step="0.01"
            />
            <button
              class="btn btn-success btn-sm ms-2"
              (click)="guardarSalarioMVM()"
            >
              Guardar
            </button>
            <button
              class="btn btn-danger btn-sm ms-1"
              (click)="cancelarEdicion()"
            >
              X
            </button>
          </div>
        </ng-template>
      </div>
    </div>

    <app-plan-modal></app-plan-modal>
    <div class="table-responsive">
      <table id="tablaPlanes" class="table table-striped table-bordered">
        <thead class="thead-light">
          <tr></tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>
